// routes
import { PATH_AUTH } from '../../routes/paths';
// hooks
import useLocales from '../../hooks/useLocales';
// components
import Page from '../../components/Page';
// sections
import { LoginForm } from '../../sections/auth/login';
import AuthLayout from '../../sections/auth/AuthLayout';
import AuthSocial from '../../sections/auth/AuthSocial';

// ----------------------------------------------------------------------

export default function Login() {
  const { translate } = useLocales();

  return (
    <Page title="Login">
      <AuthLayout
        title={translate('login.welcome')}
        description={translate('login.signin.description')}
        prompt={translate('login.signup.title')}
        actionLabel={translate('login.signup.button')}
        actionTo={PATH_AUTH.register}
      >
        <AuthSocial />
        <LoginForm />
      </AuthLayout>
    </Page>
  );
}
